import React from "react";
import { Leaf, Heart, Sparkles, Box } from "lucide-react";

export default function About() {
    React.useEffect(() => { document.title = "Our Story | Loomara"; }, []);
    return (
        <div data-testid="about-page">
            <section className="container-boutique py-16 lg:py-24 text-center">
                <p className="eyebrow">Our Story</p>
                <h1 className="font-serif text-5xl sm:text-6xl text-ink-900 mt-4 leading-tight">
                    A boutique born from <span className="italic text-sage-600">love</span>.
                </h1>
                <p className="max-w-2xl mx-auto text-ink-700 leading-relaxed mt-6">
                    Loomara began with a single idea — that the softest moments of childhood deserve the softest fabrics, the gentlest seams, and the most thoughtful design. Every piece is hand-finished in small batches, made to be loved, kept, and passed on.
                </p>
            </section>

            <section className="bg-sage-100 py-16">
                <div className="container-boutique grid md:grid-cols-2 gap-12 items-center">
                    <img src="https://static.prod-images.emergentagent.com/jobs/3af35290-5c18-4b44-9040-8af3e70333b3/images/854a1d4cf67b4543f9bb7c8f9ef61347034ef049f842bf92270c88e7ba9193bf.png" alt="Boutique" className="rounded-[2rem] w-full" />
                    <div>
                        <h2 className="font-serif text-4xl text-ink-900">Crafted, not manufactured.</h2>
                        <p className="text-ink-700 mt-4 leading-relaxed">
                            We work with small ateliers and family-run mills who treat fabric like a love letter. Every Loomara piece is checked by hand for softness, seam quality and lasting comfort — because little skin deserves nothing less.
                        </p>
                    </div>
                </div>
            </section>

            <section className="container-boutique py-16">
                <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
                    {[
                        { i: Leaf, t: "Naturally Sourced", s: "Cotton, linen and muslin from trusted mills." },
                        { i: Heart, t: "Hand Finished", s: "Each piece is checked by a Loomara artisan." },
                        { i: Sparkles, t: "Small Batches", s: "Limited runs to keep details perfect." },
                        { i: Box, t: "Easy Returns", s: "7-day no-fuss returns on every piece." },
                    ].map((c) => (
                        <div key={c.t} className="text-center">
                            <div className="h-14 w-14 mx-auto rounded-full border border-sage-300/40 flex items-center justify-center text-sage-600 mb-4">
                                <c.i size={20} strokeWidth={1.4} />
                            </div>
                            <p className="text-xs uppercase tracking-[0.22em] text-ink-900">{c.t}</p>
                            <p className="text-xs text-ink-500 mt-2">{c.s}</p>
                        </div>
                    ))}
                </div>
            </section>
        </div>
    );
}
